import type { ValidationReport } from '../api/types';

/** Handmatig gestart rapport, met het perspectief waarvoor het gemaakt is. */
export type StoredValidationReport = {
  perspectiveId: string;
  report: ValidationReport;
};

/**
 * Geeft het opgeslagen rapport alleen terug als het bij de huidige extractie
 * én het huidige perspectief hoort: na een perspectiefwissel (ook als de
 * validatie pas daarna klaarkomt) mag het rapport van het oude perspectief
 * niet getoond worden.
 */
export function matchStoredReport(
  stored: StoredValidationReport | null,
  extractionId: string | null,
  perspectiveId: string,
): ValidationReport | null {
  if (!stored || stored.report.extractionId !== extractionId) return null;
  return stored.perspectiveId === perspectiveId ? stored.report : null;
}
